import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Text from '@/components/common/Text';
import Box from '@/components/common/Box';
import { getMonthlyBillDetail } from '@/apis/admin';
import { QUERY_KEY } from '@/constants/queryKey';
import { ROUTER } from '@/constants/constants';
import BillInfoCard from '@/components/admin/MonthlyBillDetail/BillInfoCard';
import WorkersTable from '@/components/admin/MonthlyBillDetail/WorkersTable';
import ActionsPanel from '@/components/admin/MonthlyBillDetail/ActionsPanel';
import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

const AdminMonthlyBillDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const billId = id ? parseInt(id) : 0;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QUERY_KEY.ADMIN.MONTHLY_BILL_DETAIL, billId],
    queryFn: () => getMonthlyBillDetail(billId),
    enabled: billId > 0,
  });

  const handleBack = () => {
    navigate(ROUTER.ADMIN.MONTHLY_BILLS);
  };

  if (isLoading) {
    return (
      <Box title='청구서 상세' onClickBack={handleBack}>
        <Text>로딩 중...</Text>
      </Box>
    );
  }

  if (isError || !data?.data) {
    return (
      <Box title='청구서 상세' onClickBack={handleBack}>
        <ErrorText>
          오류가 발생했습니다:{' '}
          {error instanceof Error ? error.message : '알 수 없는 오류'}
        </ErrorText>
      </Box>
    );
  }

  const bill = data.data;

  return (
    <Box title={`청구서 #${bill.id}`} onClickBack={handleBack}>
      <Container>
        <BillInfoCard bill={bill} />
        <WorkersTable workers={bill.workers} />
        <ActionsPanel bill={bill} />
      </Container>
    </Box>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ErrorText = styled(Text)`
  color: ${Theme.colors.WARNING_RED};
`;

export default AdminMonthlyBillDetailPage;

